import React from 'react'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {TwProjectCard} from './containers'

export interface ProjectCardAddProps {
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
}

export const ProjectCardAdd = React.memo(
  React.forwardRef(({disabled, onClick}: ProjectCardAddProps, ref) => (
    <TwProjectCard
      ref={ref}
      data-test="AddProjectCard"
      $disabled={disabled}
      onClick={e => !disabled && onClick?.(e)}
      className={cn('group', 'hover:bg-interactive-l100')}
    >
      <IconTabler
        className={cn(
          'flex-none',
          'my-auto',
          'self-center',
          disabled
            ? 'text-grey-l40'
            : cn(
                'text-action-default',
                'group-hover:text-action-hover',
                'group-active:text-action-pressed'
              )
        )}
        icon="IconCirclePlus"
        customSize={16}
        viewBox="0 0 24 24"
      />
    </TwProjectCard>
  ))
)
